import React, { useMemo, Fragment, useEffect, useState, useRef, useContext } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate,useOutletContext } from "react-router-dom";
import { useForm, SubmitHandler } from "react-hook-form"
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import MpgInput from '../../../CommonFormComp/MpgInput';
import MpgAutocompleteSingle from '../../../CommonFormComp/MpgAutocompleteSingle';
import MpgAutocompleteMulti from '../../../CommonFormComp/MpgAutocompleteMulti';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const AccountTeamMemberDialog = ({ open, setOpen, accountTeamMembersListFromAPI, accountTeamMemberTableData, setAccountTeamMemberTableData }) => {
    let navigate = useNavigate();
    const {refClientAccountCmsData}=useOutletContext();
    /**form handling */
    const schema = yup.object().shape({
        name: yup.object().required("This field is required").typeError("This field is required"),
        job_position: yup.string().required(),
        bio: yup.object().required("This field is required").typeError("This field is required"),
    });

    const defaultVal = {
        name: null,
        job_position: '',
        bio: null
    }
    const rhfForAccTeamMember = useForm({
        resolver: yupResolver(schema),
        defaultValues: defaultVal
    });

    const accTeamMemberAutocompleteList = !!accountTeamMembersListFromAPI && accountTeamMembersListFromAPI.map((item) => {
        return {
            id: item.Id,
            selectOptionLabel: `${item.FirstName} ${item.LastName} (${item.EmailAddress})`,
            selectOptionValue: item.Id
        }
    })

    const selectedAccountTeamMember = rhfForAccTeamMember.watch('name')

    const [memberDetails, setMemberDetails] = useState({})

    const [bioForMember, setBioForMember] = useState([])

    const [uniqueTemplateTitleArray, setUniqueTemplateTitleArray] = useState([])

    /**clearing bio on change in member selection */
    useEffect(() => {
        if (!!selectedAccountTeamMember && selectedAccountTeamMember?.id) {
            rhfForAccTeamMember.setValue('bio', '')
        }
    }, [selectedAccountTeamMember?.id])

    useEffect(() => {
        if (!!selectedAccountTeamMember && selectedAccountTeamMember.id) {
            const foundMember = accountTeamMembersListFromAPI.find((item) => item.Id === selectedAccountTeamMember.id)

            if (!!foundMember) {
                setBioForMember(foundMember.BioDetail)
                rhfForAccTeamMember.setValue('job_position', foundMember.JobPosition || '')
                setMemberDetails(foundMember)

                /** we need to display only unique templateTitle names irrespective of its language for bio in dropdown, but while storing we need bioId and bioTitle in DB. For this we will grab first matched bio irrespective of its language to store in DB */

                /** grabbing all template titles and creating array of unique enties. */
                let onlyBioTemplateTitleArray = []
                !!foundMember?.BioDetail && foundMember?.BioDetail.forEach((item) => {
                    onlyBioTemplateTitleArray.push(item?.TemplateTitle)
                })
                const uniqueTemplateTitleSet = new Set(onlyBioTemplateTitleArray)

                setUniqueTemplateTitleArray(Array.from(uniqueTemplateTitleSet))
            }
        }
    }, [selectedAccountTeamMember])

    const uniqueTemplateTitleAutocompleteList = !!uniqueTemplateTitleArray && uniqueTemplateTitleArray.map((item) => {
        return {
            id: item,
            selectOptionLabel: item,
            selectOptionValue: item
        }
    })

    /** */
    const handleClose = (event, reason) => {
        if (reason && reason == "backdropClick") {
            return '';
        } else {
            setOpen(false);
        }
        rhfForAccTeamMember.reset(defaultVal)
    }

    const onSubmit = (data) => {
        /**finding first bio match for selected bioTemplate for bioId and bioTitle*/
        let bioId = "";
        let bioTitle = "";

        const foundItem = !!bioForMember && bioForMember?.find((item) => item.TemplateTitle === data.bio.id);
        if (!!foundItem) {
            bioId = foundItem.Id
            bioTitle = foundItem.TemplateTitle
        }

        const memberData = {
            teamMemberId: data.name.id,
            name: `${memberDetails.FirstName} ${memberDetails.LastName}`,
            email: memberDetails.EmailAddress,
            contact: memberDetails.ContactNo,
            jobPosition: data.job_position,
            bioId,
            bioTitle,
        }
        setAccountTeamMemberTableData([...accountTeamMemberTableData, memberData])

        handleClose()
    }

    /**ele from this list used to disable options in autocomplete */
    const [idListTobeDisabled, setIdListTobeDisabled] = useState([])
    useEffect(() => {
        if (!!accountTeamMemberTableData) {
            const list = accountTeamMemberTableData.map((item) => {
                return item.teamMemberId
            })
            setIdListTobeDisabled(list)
        }
    }, [accountTeamMemberTableData])

    const fetchAccountTeamMemberCmsData = (key) => {
        if (refClientAccountCmsData?.Components && refClientAccountCmsData?.Components["ClientAccounts.AccountTeamMembers"]) {
            const adminClientSubAccountCmsDataLabel = refClientAccountCmsData?.Components["ClientAccounts.AccountTeamMembers"];
            return returnLabel(adminClientSubAccountCmsDataLabel?.Labels, key)
        }
        return '';
    }

    const fetchCommonComponentCMSLabel = (key) => {
        if (refClientAccountCmsData?.Components && refClientAccountCmsData?.Components["CommonComponent"]) {
            const commonComponentLabel = refClientAccountCmsData?.Components["CommonComponent"];
            return returnLabel(commonComponentLabel?.Labels, key)
        }
        return '';
    }
    const returnLabel = (labelArray = [], key) => {
        return labelArray.find((x) => x.Key === key)?.Phrase || '';
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            disableEscapeKeyDown
            fullWidth
        >
            <Box
                component="form"
                noValidate
                autoComplete="off"
                onSubmit={rhfForAccTeamMember.handleSubmit(onSubmit)}
            >

                <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
                    {fetchAccountTeamMemberCmsData('AccountTeamMembers.SelectAccountTeamMember')}
                    <IconButton
                        sx={{ ml: 'auto' }}
                        onClick={handleClose}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                    >
                        <MpgAutocompleteSingle
                            rhfFormInstance={rhfForAccTeamMember}
                            label={fetchAccountTeamMemberCmsData('AccountTeamMembers.AccountTeamMemberName')}
                            name={'name'}
                            fullWidth
                            optionList={accTeamMemberAutocompleteList || []}
                            disabledOptionIdArray={idListTobeDisabled || []}
                        />

                        <MpgInput
                            rhfFormInstance={rhfForAccTeamMember}
                            label={fetchAccountTeamMemberCmsData('AccountTeamMembers.JobPosition')}
                            name={'job_position'}
                            fullWidth
                            disabled
                        />

                        <MpgAutocompleteSingle
                            rhfFormInstance={rhfForAccTeamMember}
                            label={fetchAccountTeamMemberCmsData('AccountTeamMembers.BioTemplate')}
                            name={'bio'}
                            fullWidth
                            optionList={uniqueTemplateTitleAutocompleteList || []}
                        />
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button type='submit'>{fetchCommonComponentCMSLabel('Common.Add')}</Button>
                    <Button onClick={handleClose}>{fetchCommonComponentCMSLabel('Common.Cancel')}</Button>
                </DialogActions>
            </Box>

        </Dialog>
    )
}
export default AccountTeamMemberDialog